// COLLECTION OF HELPER FUNCTIONS FOR PAYMENT

/**
 * Returns the name of the icon for a paymentMethod
 * @param paymentMethod
 * @returns {string}
 */
export function getIconForPaymentMethod(paymentMethod: string, optionService: any) {
    switch (paymentMethod) {
        case "generic":
            const paymentOptions = optionService.getOrganisationData("payment_generic");
            paymentMethod = paymentOptions.icon;
            break;
        case "konfipay":
        case "debit":
            paymentMethod = 'sepa-icon';
            break;
        case "apple_pay":
        case "stripe_apple_pay":
            paymentMethod = 'applepay';
            break;
        case "google_pay":
        case "stripe_google_pay":
            paymentMethod = 'googlepay';
            break;
        case "paydirekt":
            paymentMethod = 'giropay';
            break;
        case "sofortueberweisung":
            paymentMethod = 'sofort';
            break;
        case "sixpay":
        case "betterpayment_creditcard":
            paymentMethod = 'creditcard';
            // check if amex is available
            const saferpayToggle = optionService.getOrganisationData('saferpay_toggle');
            paymentMethod += saferpayToggle?.has_credit_card_american_express ? '-amex' : '';
            break;
        case "paypal_guest":
            paymentMethod = 'creditcard-amex'
            break
        case "stripe_creditcard":
          paymentMethod = 'creditcard-amex';
          break;
        case "banktransfer":
            paymentMethod = 'banktransfer-icon';
            break;
        case "mbe4":
            paymentMethod = 'mobilepayment-icon';
            break;
        default:
            break;
    }
    return 'payment-' + paymentMethod;
}

/**
 * Gets the titles for all activated credit cards and returns them as a comma separated string
 * @param optionService 
 * @returns {string}
 */
export function getCreditCardTitles(optionService: any) : string {
    let creditCardTitles = [];

    const saferpayToggle = optionService.getOrganisationData('saferpay_toggle');

    if (saferpayToggle?.has_credit_card_american_express) {
      creditCardTitles.push('American Express');
    }
    if (saferpayToggle?.has_credit_card_mastercard) {
      creditCardTitles.push('Mastercard');
    }
    if (saferpayToggle?.has_credit_card_visa) {
        creditCardTitles.push('Visa');
    }
    if (saferpayToggle?.has_credit_card_diners_club) {
        creditCardTitles.push('Diners Club');
    }
    if (saferpayToggle?.has_credit_card_jcb) {
        creditCardTitles.push('JCB');
    }
    if (saferpayToggle?.has_credit_card_maestro_international) {
        creditCardTitles.push('Maestro International');
    }
    if (saferpayToggle?.has_credit_card_china_union_pay) {
        creditCardTitles.push('China Union Pay');
    }

    return creditCardTitles.join(', ');
}
